import * as React from 'react'

interface Props {
    icon?: 'info' | 'exclamation-triangle' | 'exclamation-circle'
    children?: React.ReactNode
}

export class AlertTitle extends React.Component<Props> {
    public render = () => (
        <h4>
            {this.props.icon ? <i className={'fa fa-' + this.props.icon} aria-hidden={'true'} /> : null}
            {this.props.children}
        </h4>
    )
}
